import { createSlice } from "@reduxjs/toolkit";
import {
  ForgotPassword,
  LoginUser,
  LogoutUser,
  ResetPassword,
} from "./AuthApi";
import { toast } from "react-toastify";

const initialState = {
  userData: null,
  status: "idle",
  error: null,
  resetPassword: false,
  token: null,
  forgotData: null,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setForgotData: (state, action) => {
      state.forgotData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LoginUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(LoginUser.fulfilled, (state, { payload }) => {
        if (payload?.data?.token) {
          state.status = "succeeded";
          state.userData = payload.data;
          state.token = payload.token;
          localStorage.setItem("bearerToken", payload?.data?.token);
        } else {
          state.status = "failed";
          state.error = payload?.message_en;
          toast.error(payload?.message_en);
          state.token = null;
          localStorage.removeItem("bearerToken");
        }
      })
      .addCase(LoginUser.rejected, (state, { payload }) => {
        state.status = "failed";
        state.error = payload;
      })
      .addCase(ForgotPassword.pending, (state, { payload }) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(ForgotPassword.fulfilled, (state, { payload }) => {
        state.resetPassword = payload;
      })
      .addCase(ResetPassword.pending, (state, { payload }) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(ResetPassword.fulfilled, (state, { payload }) => {
        if (payload?.success) {
          state.status = "succeeded";
          state.forgotData = null;
        } else {
          state.status = "failed";
          state.error = payload?.message_en;
          toast.error(payload?.message_en);
        }
      })
      .addCase(LogoutUser.fulfilled, (state, { payload }) => {
        if (payload?.success) {
          state.userData = null;
          state.token = null;
          state.forgotData = null;
          localStorage.removeItem("bearerToken");
          localStorage.removeItem("branch_settings");
        }
      });
  },
});

export const { setForgotData } = AuthSlice.actions;
export default AuthSlice.reducer;
